export default {
    isExpanded(element) {
        return element.getAttribute('aria-expanded') === 'true';
    }
};
